import { render } from "./Loader.vue?vue&type=template&id=04a0d67a&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=04a0d67a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a0d67a"],['__file',"src/components/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04a0d67a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04a0d67a', __exports__)) {
    api.reload('04a0d67a', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=04a0d67a&scoped=true", () => {
    api.rerender('04a0d67a', render)
  })

}


export default __exports__